/** Brief 12, K3 Suhbatlar. */
export const uzB12Inbox = {
  "inbox12.title": "Suhbatlar",
  "inbox12.back": "Ro'yxatga qaytish",
  "inbox12.live": "Real vaqtda",
  "inbox12.filter.label": "Filtr",
  "inbox12.filter.new": "Yangi · olinmagan",
  "inbox12.filter.me": "Meniki",
  "inbox12.filter.wait": "Javob kutmoqda",
  "inbox12.filter.ai": "AI javobi tasdiqda",
  "inbox12.filter.late": "Kechikkan",
  "inbox12.filter.all": "Hammasi",
  "inbox12.filter.javobsiz24": "Javobsiz 24 soat",
  "inbox12.filter.closed": "Yopilgan",
  "inbox12.channel.all": "Hammasi",
  "inbox12.channel.telegram": "Telegram",
  "inbox12.channel.instagram": "Instagram DM",
  "inbox12.channel.instagram_comment": "Instagram izoh",
  "inbox12.search": "Ism, telefon yoki xabar matni",
  "inbox12.noMatch": "Filtrga mos suhbat yo'q.",
  "inbox12.empty.title": "Suhbat yo'q",
  "inbox12.empty.text": "Mijoz yozganda suhbat shu yerda ochiladi. Birinchi xabarni o'zingiz ham yozishingiz mumkin.",
  "inbox12.empty.action": "Mijozlarga",
  "inbox12.pick": "Suhbatni tanlang",
  "inbox12.select": "Ommaviy xabar uchun tanlash",
  "inbox12.bulk": "Ommaviy xabar ({count})",
  "inbox12.commentsPage": "Kommentlar sahifasi",
  "inbox12.row.late": "Kechikkan · {status}",
  "inbox12.row.aiOff": "AI o'chiq",
  "inbox12.row.claim": "Olish",
  "inbox12.row.assign": "Biriktirish",
  "inbox12.row.need": "AI aniqladi:",
  "inbox12.row.closed": "Yopilgan · {outcome}",
  "inbox12.owner.label": "Mas'ul:",
  "inbox12.owner.none": "olinmagan",
  "inbox12.owner.change": "Mas'ulni almashtirish",
  "inbox12.owner.pick": "Mas'ulni tanlang",
  "inbox12.owner.done": "Mas'ul: {name}",
  "inbox12.owner.failed": "Mas'ulni almashtirib bo'lmadi.",
  "inbox12.owner.error": "Xodimlar ro'yxatini yuklab bo'lmadi.",
  "inbox12.owner.empty": "Berish uchun xodim yo'q.",
  "inbox12.give": "Boshqaga berish",
  "inbox12.close": "Suhbatni yopish",
  "inbox12.closeShort": "Yopish",
  "inbox12.client": "Mijoz",
  "inbox12.claim.done": "{name} sizga biriktirildi",
  "inbox12.deal.create": "Bitim yaratish",
  "inbox12.deal.open": "Bitimni ochish",
  "inbox12.reopen": "Qayta ochish",
  "inbox12.reopened": "Suhbat qayta ochildi",
  "inbox12.reopenFailed": "Suhbatni qayta ochib bo'lmadi.",
  "inbox12.ai.offNote": "AI o'chiq · operator javob beradi",
  "inbox12.ai.turnedOff": "AI o'chirildi · operator javob beradi",
  "inbox12.ai.turnedOn": "AI yoqildi · birinchi javobni AI beradi",
  "inbox12.ai.withNote": "Ko'rsatma bilan qaytarish",
  "inbox12.ai.note": "AI uchun ko'rsatma (ixtiyoriy)",
  "inbox12.ai.return": "AI davom ettirsin",
  "inbox12.ai.failed": "Rejimni o'zgartirib bo'lmadi.",
  "inbox12.closeDialog.bought": "Tur sotib oldi",
  "inbox12.closeDialog.refused": "Rad etdi",
  "inbox12.closeDialog.went_quiet": "Javob bermay qoldi",
  "inbox12.closeDialog.spam": "Spam",
  "inbox12.closeDialog.toBooked": "Bitim «Bron» bosqichiga o'tadi",
  "inbox12.closeDialog.noBooking": "Bron kiritilmagan: bitim joyida qoladi va vazifa ochiladi",
  "inbox12.closeDialog.toLost": "Bitim «Yo'qotildi» bosqichiga o'tadi · sabab: {reason}",
  "inbox12.closeDialog.quiet": "javob bermadi",
  "inbox12.closeDialog.toSpam": "Bitim yaratilmaydi, suhbat arxivga tushadi",
  "inbox12.closeDialog.done": "Suhbat yopildi · {outcome}",
  "inbox12.closeDialog.failed": "Suhbatni yopib bo'lmadi.",
  "inbox12.task.call": "Qo'ng'iroq",
  "inbox12.task.message": "Xabar",
  "inbox12.task.document": "Hujjat",
  "inbox12.task.payment": "To'lov",
  "inbox12.task.followUp": "Qayta aloqa",
  "inbox12.task.add": "Vazifa qo'shish",
  "inbox12.task.added": "Vazifa qo'shildi · {name}",
  "inbox12.task.failed": "Vazifani saqlab bo'lmadi.",
  "inbox12.task.completeFailed": "Vazifani yopib bo'lmadi.",
  "inbox12.task.today": "Bugun",
  "inbox12.panel.need": "aniqlangan ehtiyoj",
  "inbox12.panel.needField.destination": "Yo'nalish",
  "inbox12.panel.needField.dates": "Sana",
  "inbox12.panel.needField.party": "Kishilar",
  "inbox12.panel.needField.service": "Xizmat",
  "inbox12.panel.firstContact": "Birinchi murojaat: {date}",
  "inbox12.panel.allChannels": "Barcha kanallardagi xabarlar",
  "inbox12.panel.thisThread": "Faqat shu suhbat",
  "inbox12.panel.more": "Batafsil: portret, bitimlar, tarix",
  "inbox12.panel.closedAs": "Yakuni",
  "inbox12.composer.label": "Javob yozish",
  "inbox12.composer.text": "Xabar",
  "inbox12.composer.placeholder": "Xabar yozing. «/» shablonlar",
  "inbox12.composer.notePlaceholder": "Ichki izoh. Mijoz ko'rmaydi",
  "inbox12.composer.send": "Yuborish",
  "inbox12.composer.sendNote": "Izoh",
  "inbox12.composer.needsClaim": "Javob berish uchun avval suhbatni oling.",
  "inbox12.composer.chips": "Tez tugmalar",
  "inbox12.draft.title": "Kapitan AI · qoralama",
  "inbox12.card.page": "Taklif sahifasi",
  "inbox12.card.nights": "{count} kecha",
  "inbox12.card.pax": "{count} kishi",
  "inbox12.message.staffMeta": "{name} · {time}",
} as const;
